import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { FetchGlobalServiceProfileParams } from '@module/apis/client-side/global-service/type';

export const globalServiceQueryKeys = createQueryKeys('globalService', {
  fetchGlobalServiceProfile: (params: FetchGlobalServiceProfileParams) => [params],
  fetchGlobalServiceProfileUpdate: () => ['fetchGlobalServiceProfileUpdate'],
  fetchGlobalServiceProfileTranslate: () => ['fetchGlobalServiceProfileTranslate'],
});
